import _ from 'lodash';import React from 'react';
import { gql, useQuery } from '@apollo/client';
import { Redirect } from 'react-router-dom';
import { useHistory } from 'react-router';

// Data
import { getAuthUser } from '../../../lib/services/auth.service';

// Components
import AssessmentSelectorContainer from './assessment-selector.container';
import { buildUpdateUserSettings } from '../../../lib/services/user.service';
import { useRoleAllowedAssessments } from '../../../lib/services/assessment.service';
import { sortAssessmentsNewestFirst } from '../../../lib/helpers/assessment.helpers';

const GET_ASSESSMENT_SELECTOR_QUERY = gql`
  query GetAssessmentSelector($companyId: ID!) {
    assessments(companyId: $companyId) {
      _id
      name
      createdAt
      ageGroupIds
    }
  }
`;

// `autoSwitchInvalidActive` (default true) lets an instance rewrite the global
// active assessment; aux mounts pass false — see AssessmentSelector/README.md.
export const AssessmentSelectorGraphQL = ({requiredRoles, disabled, autoSwitchInvalidActive = true}: {requiredRoles?: string[]; disabled?: boolean; autoSwitchInvalidActive?: boolean}) => {
  const history = useHistory();
  const user = getAuthUser();

  const { data, error, loading } = useQuery(GET_ASSESSMENT_SELECTOR_QUERY, {
    fetchPolicy: 'cache-and-network',
    skip: !user,
    variables: { companyId: user && user.settings.activeCompanyId }
  });

  const { updateUserSettings } = buildUpdateUserSettings();
  const assessments = (data && data.assessments) || [];
  const allowedAssessments = useRoleAllowedAssessments({ assessments, requiredRoles });

  const assessmentIds = _.map(allowedAssessments, '_id');

  if (autoSwitchInvalidActive && assessmentIds.length && !_.includes(assessmentIds, user?.settings.activeAssessmentId)) {
    const sortAssessments = sortAssessmentsNewestFirst(allowedAssessments);
    const sortedIds = _.map(sortAssessments, '_id');

    updateUserSettings({
      activeAssessmentId: sortedIds[0],
      activeCompanyId: user?.settings.activeCompanyId
    }, { userInitiated: false });
  }

  if (autoSwitchInvalidActive && !loading && allowedAssessments.length === 0 && history.location.pathname !== '/assessments/create') {
    return <Redirect to="/assessments/create" />;
  }

  const switchAssessmentMutation = (assessmentId: string) =>
    updateUserSettings({ activeAssessmentId: assessmentId });

  return <AssessmentSelectorContainer
    switchAssessmentMutation={switchAssessmentMutation}
    fetchError={Boolean(error)}
    loading={loading}
    user={user}
    assessments={allowedAssessments}
    disabled={disabled}
  />;
};
